//import { useEffect,useState } from "react";
import { useState } from "react";
import logo from '../assets/pra_logo.jpg';
import BASE_URL from '../config';
//import axios from 'axios';
const genders = ["Male", "Female", "Other"];
const styles = {
  body: {
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    background: "#f5f7fa",
    minHeight: "100vh",
    padding: "2rem 1rem 4rem",
    margin: 0,
  },
  wrapper: {
    maxWidth: "860px",
    margin: "0 auto",
  },
  header: {
    background: "#0f5c3a",
    borderRadius: "10px 10px 0 0",
    padding: "2rem 2.5rem 1.5rem",
    display: "flex",
    alignItems: "center",
    gap: "1.5rem",
    position: "relative",
    overflow: "hidden",
  },
  logo: {
    width: "70px",
    height: "70px",
    borderRadius: "50%",
   /*  background: "#c9a227", */
   background: "#fff",
    overflow: "hidden",
  border: "2px solid #c9a227",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    fontSize: "26px",
    fontWeight: "700",
    color: "#0f5c3a",
    letterSpacing: "-1px",
  },
  schoolName: {
    fontFamily: "Georgia, serif",
    fontSize: "20px",
    fontWeight: "600",
    color: "#fff",
    lineHeight: 1.3,
    margin: 0,
  },
  schoolSub: {
    fontSize: "13px",
    color: "rgba(255,255,255,0.7)",
    marginTop: "4px",
    marginBottom: 0,
  },
  badge: {
    display: "inline-block",
    marginTop: "8px",
    background: "#c9a227",
    color: "#0f5c3a",
    fontSize: "11px",
    fontWeight: "600",
    padding: "3px 12px",
    borderRadius: "20px",
    letterSpacing: "0.04em",
  },
  formCard: {
    background: "#fff",
    border: "1px solid #d4dde8",
    borderTop: "none",
    borderRadius: "0 0 10px 10px",
    padding: "2rem 2.5rem 2.5rem",
    boxShadow: "0 2px 12px rgba(15,92,58,0.08)",
  },
  section: {
    marginBottom: "2rem",
  },
  sectionLabel: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "11px",
    fontWeight: "600",
    color: "#1a7a4e",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    marginBottom: "1.25rem",
  },
  sectionLine: {
    flex: 1,
    height: "1px",
    background: "#e8f5ef",
  },
  sectionNum: {
    width: "22px",
    height: "22px",
    borderRadius: "50%",
    background: "#e8f5ef",
    color: "#1a7a4e",
    fontSize: "11px",
    fontWeight: "700",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  grid2: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "1.25rem 1.5rem",
  },
  grid3: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "1.25rem 1.5rem",
  },
  colFull: {
    gridColumn: "1 / -1",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  kannada: {
    fontFamily: "'Noto Sans Kannada', 'Kannada Sangam MN', sans-serif",
    fontSize: "13px",
    color: "#1a1a1a",
    lineHeight: 1.4,
  },
  sublabel: {
    fontSize: "11px",
    color: "#5a6272",
    marginTop: "1px",
  },
  required: {
    color: "#c0392b",
    marginLeft: "2px",
  },
  input: {
    width: "100%",
    height: "42px",
    padding: "0 14px",
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    fontSize: "14px",
    color: "#1a1a1a",
    background: "#fafbfc",
    border: "1.5px solid #d4dde8",
    borderRadius: "8px",
    outline: "none",
    boxSizing: "border-box",
    transition: "border-color 0.18s, box-shadow 0.18s",
  },
  textarea: {
    width: "100%",
    height: "100px",
    padding: "12px 14px",
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    fontSize: "14px",
    color: "#1a1a1a",
    background: "#fafbfc",
    border: "1.5px solid #d4dde8",
    borderRadius: "8px",
    outline: "none",
    resize: "vertical",
    boxSizing: "border-box",
  },
  select: {
    width: "100%",
    height: "42px",
    padding: "0 36px 0 14px",
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    fontSize: "14px",
    color: "#1a1a1a",
    background: "#fafbfc",
    border: "1.5px solid #d4dde8",
    borderRadius: "8px",
    outline: "none",
    appearance: "none",
    cursor: "pointer",
    boxSizing: "border-box",
    //backgroundImage: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%235a6272' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E"),
    backgroundImage:
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%235a6272' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E\")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 14px center",
  },
  uploadZone: {
    border: "2px dashed #d4dde8",
    borderRadius: "8px",
    padding: "1.25rem",
    display: "flex",
    alignItems: "center",
    gap: "14px",
    cursor: "pointer",
    background: "#fafbfc",
    transition: "border-color 0.18s, background 0.18s",
  },
  uploadIconBox: {
    width: "48px",
    height: "48px",
    flexShrink: 0,
    background: "#e8f5ef",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  uploadBtn: {
    marginLeft: "auto",
    padding: "7px 16px",
    background: "#fff",
    border: "1.5px solid #d4dde8",
    borderRadius: "7px",
    fontSize: "12px",
    fontWeight: "500",
    color: "#1a1a1a",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  note: {
    marginTop: "1.25rem",
    padding: "0.75rem 1rem",
    background: "#fdf6e3",
    borderLeft: "3px solid #c9a227",
    borderRadius: "0 6px 6px 0",
    fontSize: "12px",
    color: "#7a6010",
    lineHeight: 1.6,
  },
  submitRow: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    marginTop: "2rem",
    paddingTop: "1.5rem",
    borderTop: "1px solid #d4dde8",
  },
  submitBtn: {
    flex: 1,
    height: "48px",
    background: "#0f5c3a",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    fontSize: "15px",
    fontWeight: "500",
    cursor: "pointer",
    letterSpacing: "0.02em",
    transition: "background 0.18s",
  },
  resetBtn: {
    height: "48px",
    padding: "0 22px",
    background: "transparent",
    border: "1.5px solid #d4dde8",
    borderRadius: "10px",
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    fontSize: "14px",
    color: "#5a6272",
    cursor: "pointer",
  },
  successBox: {
    textAlign: "center",
    padding: "3rem 2rem",
    background: "#fff",
    border: "1px solid #d4dde8",
    borderRadius: "10px",
    marginTop: "1rem",
  },
  successIcon: {
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    background: "#e8f5ef",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 1rem",
  },
};

const classes = ["1st","2nd","3rd","4th","5th","6th","7th","8th","9th","10th"];
const categories = ["General","OBC","SC","ST"];

const initialForm = {
  photo: null,
  admissionClass: "",
  dob: "",
   gender: "",
  studentName: "",
  fatherName: "",
  motherName: "",
  aadhar: "",
  category: "",
  mobile: "",
  whatsapp: "",
  email: "",
  address: "",
  prevSchool: "",
  prevClass: "",
};

function Field({ kannada, english, required, children }) {
  return (
    <div style={styles.field}>
      <span style={styles.kannada}>
        {kannada} {required && <span style={styles.required}>*</span>}
      </span>
      <span style={styles.sublabel}>{english}</span>
      {children}
    </div>
  );
}

function SectionHeader({ num, title }) {
  return (
    <div style={styles.sectionLabel}>
      <span style={styles.sectionNum}>{num}</span>
      {title}
      <span style={styles.sectionLine} />
    </div>
  );
}

export default function App() {
  const [form, setForm] = useState(initialForm);
  const [fileName, setFileName] = useState("No file chosen");
  const [submitted, setSubmitted] = useState(false);
  const [focusedField, setFocusedField] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      setForm({ ...form, photo: file });
    }
  };

  const handleReset = () => {
    setForm(initialForm);
    setFileName("No file chosen");
    setSubmitted(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    //setSubmitted(true);
      try {
    const formData = new FormData();

    formData.append("photo", form.photo);
    formData.append("admissionClass", form.admissionClass);
    formData.append("dob", form.dob);
    formData.append("gender", form.gender);
    formData.append("studentName", form.studentName);
    formData.append("fatherName", form.fatherName);
    formData.append("motherName", form.motherName);
    formData.append("aadhar", form.aadhar);
    formData.append("category", form.category);
    formData.append("mobile", form.mobile);
    formData.append("whatsapp", form.whatsapp);
    formData.append("email", form.email);
    formData.append("address", form.address);
    formData.append("prevSchool", form.prevSchool);
    formData.append("prevClass", form.prevClass);

    const response = await fetch(
      `${BASE_URL}/api/student/register`,
      {
        method: "POST",
        body: formData,
      }
    );

    const data = await response.json();

    if (data.success) {
      alert(data.message);
      setSubmitted(true);
    } else {
      alert(data.message);
    }
  } catch (error) {
    console.log(error);

    alert("Something went wrong");
  }
};

  const focusStyle = (name) =>
    focusedField === name
      ? { ...styles.input, borderColor: "#1a7a4e", background: "#fff", boxShadow: "0 0 0 3px rgba(26,122,78,0.1)" }
      : styles.input;

  const focusSelectStyle = (name) =>
    focusedField === name
      ? { ...styles.select, borderColor: "#1a7a4e", background: "#fff", boxShadow: "0 0 0 3px rgba(26,122,78,0.1)" }
      : styles.select;

  const focusTextareaStyle = (name) =>
    focusedField === name
      ? { ...styles.textarea, borderColor: "#1a7a4e", background: "#fff", boxShadow: "0 0 0 3px rgba(26,122,78,0.1)" }
      : styles.textarea;

  return (
    <div style={styles.body}>
      <link
        href="https://fonts.googleapis.com/css2?family=Noto+Sans+Kannada:wght@400;500;600&family=DM+Sans:wght@400;500&display=swap"
        rel="stylesheet"
      />
      <div style={styles.wrapper}>

        {/* ── Header ── */}
        <div style={styles.header}>
         {/*  <div style={styles.logo}>SPBSES</div> */}
         <div style={styles.logo}>
  <img
    src={logo}
    alt="School Logo"
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "50%",
    }}
  />
</div>
          <div>
            <p style={styles.schoolName}>Shree Pavada Basaveshwar School</p>
            <p style={styles.schoolSub}>ಶ್ರೀ ಪವಾಡ ಬಸವೇಶ್ವರ ಶಾಲೆ</p>
            <span style={styles.badge}>Admission Form — 2026–27</span>
          </div>
        </div>

        {/* ── Success State ── */}
        {submitted ? (
          <div style={styles.successBox}>
            <div style={styles.successIcon}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#1a7a4e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <h2 style={{ fontFamily: "Georgia, serif", color: "#0f5c3a", marginBottom: "0.5rem" }}>
              Application Submitted!
            </h2>
            <p style={{ color: "#5a6272", fontSize: "14px", marginBottom: "1.5rem" }}>
              Thank you, <strong>{form.studentName}</strong>. The school will contact you at <strong>{form.mobile}</strong> shortly.
            </p>
            <button style={{ ...styles.submitBtn, flex: "none", padding: "0 2rem" }} onClick={handleReset}>
              Submit Another
            </button>
          </div>
        ) : (

        /* ── Form ── */
        <div style={styles.formCard}>
          <form onSubmit={handleSubmit}>

            {/* Section 1 */}
            <div style={styles.section}>
              <SectionHeader num="1" title="Basic Details" />
              <div style={styles.grid2}>

                {/* Photo Upload */}
                <div style={{ ...styles.field, ...styles.colFull }}>
                  <span style={styles.kannada}>ಇತ್ತೀಚಿನ ಭಾವ ಚಿತ್ರ ಲಗತ್ತಿಸಿ <span style={styles.required}>*</span></span>
                  <span style={styles.sublabel}>Please upload Student recent Passport size Photo</span>
                  <label style={styles.uploadZone} htmlFor="photo">
                    <div style={styles.uploadIconBox}>
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1a7a4e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12" />
                      </svg>
                    </div>
                    <div>
                      <div style={{ fontSize: "13px", fontWeight: "500", color: "#1a1a1a" }}>{fileName}</div>
                      <div style={{ fontSize: "12px", color: "#5a6272", marginTop: "2px" }}>JPG, PNG — max 2 MB</div>
                    </div>
                    <button type="button" style={styles.uploadBtn}>Choose File</button>
                    <input type="file" id="photo" accept="image/*" style={{ display: "none" }} onChange={handleFile} />
                  </label>
                </div>

                <Field kannada="ಪ್ರವೇಶಾತಿ ಪಡೆಯುವ ತರಗತಿ" english="Admission Class for 26-27" required>
                  <select
                    name="admissionClass"
                    value={form.admissionClass}
                    onChange={handleChange}
                    onFocus={() => setFocusedField("admissionClass")}
                    onBlur={() => setFocusedField(null)}
                    style={focusSelectStyle("admissionClass")}
                    required
                  >
                    <option value="">-- Select Class --</option>
                    {classes.map((c) => <option key={c}>{c}</option>)}
                  </select>
                </Field>

                <Field kannada="ವಿದ್ಯಾರ್ಥಿಯ ಹುಟ್ಟಿದ ದಿನಾಂಕ" english="Student Date of Birth" required>
                  <input
                    type="date"
                    name="dob"
                    value={form.dob}
                    onChange={handleChange}
                    onFocus={() => setFocusedField("dob")}
                    onBlur={() => setFocusedField(null)}
                    style={focusStyle("dob")}
                    required
                  />
                </Field>
                <Field kannada="ಲಿಂಗ" english="Gender" required>
  <select
    name="gender"
    value={form.gender}
    onChange={handleChange}
    onFocus={() => setFocusedField("gender")}
    onBlur={() => setFocusedField(null)}
    style={focusSelectStyle("gender")}
    required
  >
    <option value="">-- Select Gender --</option>

    {genders.map((g) => (
      <option key={g} value={g}>
        {g}
      </option>
    ))}
  </select>
</Field>
              </div>
            </div>

            {/* Section 2 */}
            <div style={styles.section}>
              <SectionHeader num="2" title="Student Information" />
              <div style={styles.grid2}>

                <div style={{ ...styles.field, ...styles.colFull }}>
                  <span style={styles.kannada}>ವಿದ್ಯಾರ್ಥಿಯ ಹೆಸರು <span style={styles.required}>*</span></span>
                  <span style={styles.sublabel}>Student Name</span>
                  <input
                    type="text" name="studentName" value={form.studentName}
                    onChange={handleChange} placeholder="Enter full name"
                    onFocus={() => setFocusedField("studentName")}
                    onBlur={() => setFocusedField(null)}
                    style={focusStyle("studentName")} required
                  />
                </div>

                <Field kannada="ವಿದ್ಯಾರ್ಥಿಯ ತಂದೆಯ ಹೆಸರು" english="Student's Father Name" required>
                  <input
                    type="text" name="fatherName" value={form.fatherName}
                    onChange={handleChange} placeholder="Father's full name"
                    onFocus={() => setFocusedField("fatherName")}
                    onBlur={() => setFocusedField(null)}
                    style={focusStyle("fatherName")} required
                  />
                </Field>

                <Field kannada="ವಿದ್ಯಾರ್ಥಿಯ ತಾಯಿಯ ಹೆಸರು" english="Students Mother Name" required>
                  <input
                    type="text" name="motherName" value={form.motherName}
                    onChange={handleChange} placeholder="Mother's full name"
                    onFocus={() => setFocusedField("motherName")}
                    onBlur={() => setFocusedField(null)}
                    style={focusStyle("motherName")} required
                  />
                </Field>

                <Field kannada="ವಿದ್ಯಾರ್ಥಿಯ ಆಧಾರ ಸಂಖ್ಯೆ" english="Student's Aadhar Number" required>
                  <input
                    type="text" name="aadhar" value={form.aadhar}
                    onChange={handleChange} placeholder="12-digit Aadhar number"
                    maxLength={12}
                    onFocus={() => setFocusedField("aadhar")}
                    onBlur={() => setFocusedField(null)}
                    style={focusStyle("aadhar")} required
                  />
                </Field>

                <Field kannada="ಜಾತಿ / ವರ್ಗ" english="Caste / Category">
                  <select
                    name="category" value={form.category} onChange={handleChange}
                    onFocus={() => setFocusedField("category")}
                    onBlur={() => setFocusedField(null)}
                    style={focusSelectStyle("category")}
                  >
                    <option value="">-- Select --</option>
                    {categories.map((c) => <option key={c}>{c}</option>)}
                  </select>
                </Field>
              </div>
            </div>

            {/* Section 3 */}
            <div style={styles.section}>
              <SectionHeader num="3" title="Contact Details" />
              <div style={styles.grid3}>

                <Field kannada="ಮೊಬೈಲ್ ಸಂಖ್ಯೆ" english="Mobile Number" required>
                  <input
  type="tel"
  name="mobile"
  value={form.mobile}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      setForm({ ...form, mobile: value });
    }
  }}
  placeholder="10-digit mobile number"
  maxLength={10}
  pattern="[0-9]{10}"
  required
  onFocus={() => setFocusedField("mobile")}
  onBlur={() => setFocusedField(null)}
  style={focusStyle("mobile")}
/>
                </Field>

                <Field kannada="ವಾಟ್ಸ್ಪ್ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ" english="WhatsApp Number">
                 <input
  type="tel"
  name="whatsapp"
  value={form.whatsapp}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      setForm({ ...form, whatsapp: value });
    }
  }}
  placeholder="10-digit WhatsApp number"
  maxLength={10}
  pattern="[0-9]{10}"
  onFocus={() => setFocusedField("whatsapp")}
  onBlur={() => setFocusedField(null)}
  style={focusStyle("whatsapp")}
/>
                </Field>

                <Field kannada="ಇಮೇಲ್ ವಿಳಾಸ" english="Email Address">
                  <input
                    type="email" name="email" value={form.email}
                    onChange={handleChange} placeholder="example@mail.com"
                    onFocus={() => setFocusedField("email")}
                    onBlur={() => setFocusedField(null)}
                    style={focusStyle("email")}
                  />
                </Field>

                <div style={{ ...styles.field, ...styles.colFull }}>
                  <span style={styles.kannada}>ಖಾಯಂ ವಿಳಾಸ <span style={styles.required}>*</span></span>
                  <span style={styles.sublabel}>Permanent Address</span>
                  <textarea
                    name="address" value={form.address}
                    onChange={handleChange}
                    placeholder="Door No., Street, Village / Town, District, State, PIN Code"
                    onFocus={() => setFocusedField("address")}
                    onBlur={() => setFocusedField(null)}
                    style={focusTextareaStyle("address")}
                    required
                  />
                </div>
              </div>
            </div>

            {/* Section 4 */}
            <div style={styles.section}>
              <SectionHeader num="4" title="Previous School Details" />
              <div style={styles.grid2}>
                <Field kannada="ಹಿಂದಿನ ಶಾಲೆಯ ಹೆಸರು" english="Previous School Name">
                  <input
                    type="text" name="prevSchool" value={form.prevSchool}
                    onChange={handleChange} placeholder="School name"
                    onFocus={() => setFocusedField("prevSchool")}
                    onBlur={() => setFocusedField(null)}
                    style={focusStyle("prevSchool")}
                  />
                </Field>
                <Field kannada="ಹಿಂದಿನ ತರಗತಿ" english="Previously Studied Class">
                  <select
                    name="prevClass" value={form.prevClass} onChange={handleChange}
                    onFocus={() => setFocusedField("prevClass")}
                    onBlur={() => setFocusedField(null)}
                    style={focusSelectStyle("prevClass")}
                  >
                    <option value="">-- Select --</option>
                    {classes.map((c) => <option key={c}>{c}</option>)}
                  </select>
                </Field>
              </div>
            </div>

            {/* Note */}
            <div style={styles.note}>
              &#9432;&nbsp; Fields marked with <strong>*</strong> are mandatory. Please ensure all information matches official documents. The school management reserves the right to verify submitted details.
            </div>

            {/* Submit Row */}
            <div style={styles.submitRow}>
              <button type="button" style={styles.resetBtn} onClick={handleReset}>
                Reset
              </button>
              <button type="submit" style={styles.submitBtn}>
                Submit Application →
              </button>
            </div>

          </form>
        </div>
        )}
      </div>
    </div>
  );
}